"use client";
import Image from "next/image";
import CommonTitle from "@/components/common/CommonTitle";
import adBgImage from "@/assets/images/advertisement/bg-ad-banner.svg";
import { SignUpHubspotButtonUrl } from "@/utils/hubspot-contants";
import startupsAwardImage from "@/assets/images/advertisement/leader-startups-2024.png";
import highPerformance from "@/assets/images/footer/high-performer.svg";
import userEnggagement from "@/assets/images/footer/user-engagement.svg";
import usersLoveImage from "@/assets/images/advertisement/users-love.png";
import fall2025Image from "@/assets/images/advertisement/fall-2025.png";
import CustomButton from "@/components/common/CustomButton";
import Lottie from "lottie-react";
import robotAnimation from "@/assets/images/robot-animate.json";

const badgeLogos = [
  {
    id: 1,
    src: highPerformance,
    alt: "High Performance",
  },
  {
    id: 2,
    src: usersLoveImage,
    alt: "Users Love",
  },
  {
    id: 3,
    src: fall2025Image,
    alt: "Fall 2025",
  },
  {
    id: 4,
    src: userEnggagement,
    alt: "SoftwareSuggest Award",
  },
  {
    id: 5,
    src: startupsAwardImage,
    alt: "Startups Award",
  },
];

const AdvTools = ({ title, btnText }: { title?: React.ReactNode; btnText?: string }) => {
  return (
    <>
      <section className="overflow-hidden pb-20 xl:pb-24 3xl:pb-32">
        <div className="container mx-auto px-4">
          <div className="relative z-10 overflow-hidden rounded-2xl" style={{ backgroundImage: `url(${adBgImage.src})`, backgroundSize: "cover", backgroundPosition: "center" }}>
            <div className="flex flex-col lg:flex-row items-center justify-center gap-4 w-full h-full py-8 md:py-12">
              <div className="flex h-[200px] items-center justify-center w-full lg:w-[25%]" aria-hidden="true">
                <Lottie
                  animationData={robotAnimation}
                  alt="Kroolo AI tools promotion banner"
                  className="h-full w-full object-contain"
                  loop
                  autoplay
                />
              </div>
              <div className="w-full lg:w-[75%]">
                <div className="flex flex-col items-center gap-4 text-center lg:items-start lg:text-start">
                  <CommonTitle
                    color="#FFFFFF"
                    fontSizeClass="text-[26px] xl:text-[48px]"
                    fontWeightClass="font-semibold"
                    as="h2"
                  >
                    {title || (
                      <>
                        Get Kroolo, The best of
                        <span className="bg-gradient-to-r from-[#BB34FF] to-[#FF3465] bg-clip-text text-transparent">
                          AI and Work Management
                        </span>
                      </>
                    )}
                  </CommonTitle>
                  <div className="flex flex-wrap items-center justify-center gap-4 pt-2 lg:justify-start">
                    {badgeLogos.map((logo) => (
                      <Image
                        src={logo.src}
                        alt={logo.alt}
                        className="h-16 w-auto object-contain md:h-20 lg:h-24"
                        width={112}
                        height={112}
                        key={logo.id}
                      />
                    ))}
                  </div>
                  <div className="pt-2">
                    <CustomButton
                      text={btnText || "Get Started"}
                      url={SignUpHubspotButtonUrl}
                      version="black"
                      variant="secondary"
                      textSizeBtnClass="bg-white text-black"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdvTools;
